/**
 * 页面层级序号：
 * 一级 100、200、300…
 * 二级 父序号 + 1、2、3…（100 → 101、102）
 * 三级及以下 父序号 × 100 + 1、2、3…（101 → 10101、10102）
 * 同级最多 99 个子节点。
 */

function toIndex(value) {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? n : 0
}

function readIndex(item, indexKey) {
  if (!item) return 0
  if (indexKey) return toIndex(item[indexKey])
  return toIndex(item.index != null ? item.index : item.pageIndex)
}

export function childIndexAt(parentIndex, pos) {
  const parent = toIndex(parentIndex)
  const p = Number(pos) || 1
  if (!parent) return p * 100
  if (parent % 100 === 0) return parent + p
  return parent * 100 + p
}

export function nextTopIndex(siblings, indexKey) {
  const indexes = (siblings || []).map((item) => readIndex(item, indexKey))
  const max = indexes.length ? Math.max.apply(null, indexes) : 0
  if (max < 100) return 100
  return Math.floor(max / 100) * 100 + 100
}

export function nextChildIndex(parentIndex, children, indexKey) {
  const indexes = (children || [])
    .map((item) => readIndex(item, indexKey))
    .filter((n) => n > 0)
  if (!indexes.length) return childIndexAt(parentIndex, 1)
  return Math.max.apply(null, indexes) + 1
}

export function findNodeByUid(tree, uid) {
  if (!tree || !tree.length || !uid) return null
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.pageUid === uid || node.uid === uid) return node
    const found = findNodeByUid(node.children, uid)
    if (found) return found
  }
  return null
}

export function findParentNode(tree, uid) {
  if (!tree || !tree.length || !uid) return null
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    const children = node.children || []
    if (children.some((item) => item.pageUid === uid || item.uid === uid)) {
      return node
    }
    const found = findParentNode(children, uid)
    if (found) return found
  }
  return null
}

export function nextIndexForParent(tree, parentUid, indexKey) {
  const isTop = !parentUid || parentUid === '1'
  if (isTop) return nextTopIndex(tree, indexKey)
  const parent = findNodeByUid(tree, parentUid)
  if (!parent) return nextTopIndex(tree, indexKey)
  return nextChildIndex(readIndex(parent, indexKey), parent.children, indexKey)
}

export function collectIndexUpdates(nodes, parentIndex, isTop, indexKey) {
  const updates = []
  if (!nodes || !nodes.length) return updates
  nodes.forEach((node, i) => {
    const index = isTop ? (i + 1) * 100 : childIndexAt(parentIndex, i + 1)
    const uid = node.pageUid || node.uid
    if (uid && readIndex(node, indexKey) !== index) {
      updates.push({ uid: uid, index: index })
    }
    if (node.children && node.children.length) {
      updates.push.apply(
        updates,
        collectIndexUpdates(node.children, index, false, indexKey)
      )
    }
  })
  return updates
}
